import React from 'react';

import dynamic from 'next/dynamic';

import clsx from 'clsx';

import type { SharedButtonProps } from '@hultafors/shared/components';

import { CtaButtonFragment } from '@hultafors/hultaforsgroup/types';

import styles from './button.module.scss';

const SharedButton = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.Button),
);

type CtaButtonProps = Partial<CtaButtonFragment> & SharedButtonProps;

// TODO - Implement this component in all blocks, and remove the Button component (?)
export const Button: React.FC<CtaButtonProps> = ({
  center,
  className,
  label,
  loading,
  loadingLabel,
  onClick,
  textColor = '#000',
  to,
  variant = 'fill',
  withoutStyles,
  ...props
}) => {
  const textColorStyle = variant === 'fill' ? textColor : '#FFF';

  return (
    <SharedButton
      center={center}
      className={clsx(
        className,
        styles['cta-button'],
        styles[`cta-button--${variant}`],
        withoutStyles && styles['no-styles'],
      )}
      label={label}
      loading={loading}
      loadingLabel={loadingLabel}
      onClick={onClick}
      rounded
      textColor={textColorStyle}
      to={to}
      uppercase
      withoutStyles={withoutStyles}
      {...props}
    />
  );
};
